import React from "react";

const STEPS = [
  {
    n: "01",
    t: "Tell us the job",
    b: "Search the marketplace yourself, or send us a brief. Role, outcome, budget \u2014 ten minutes.",
  },
  {
    n: "02",
    t: "Meet your match",
    b: "Hand-picked profiles in 72 hours. Interview if you want, or trust the vetting and start.",
  },
  {
    n: "03",
    t: "Work starts, we stay",
    b: "Contracts, payments and check-ins handled. On managed jobs, we own delivery with you.",
  },
];

export default function HowItWorks() {
  return (
    <section id="vetting" className="bg-ink-v2 px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-[1200px]">
        <div className="mb-3.5 text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-lime-300">
          How it works
        </div>
        <h2 className="mb-14 max-w-[640px] text-balance text-[clamp(32px,4vw,48px)] font-bold leading-[1.05] tracking-[-0.025em] text-cream-100">
          From brief to first deliverable in one week.
        </h2>

        <div className="grid grid-cols-1 gap-10 min-[900px]:grid-cols-2 min-[1100px]:grid-cols-3">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="flex min-w-0 flex-col gap-3.5 border-t-[1.5px] border-cream-100/25 pt-6"
            >
              <span className="font-mono text-[15px] font-extrabold leading-none text-lime-300">
                {s.n}
              </span>
              <h3 className="text-[30px] font-bold leading-[1.15] tracking-[-0.015em] text-cream-100">
                {s.t}
              </h3>
              <p className="text-[16px] leading-[1.55] text-cream-100/65">
                {s.b}
              </p>
            </div>
          ))}
        </div>

        <figure className="mt-16 flex flex-wrap items-center justify-between gap-8 rounded-3xl border-[1.5px] border-cream-100/20 bg-ink-v2-soft px-10 py-9">
          <blockquote className="m-0 max-w-[620px] text-[24px] font-semibold leading-[1.2] tracking-[-0.01em] text-cream-100">
            &ldquo;We briefed on a Monday, had a senior brand designer embedded
            by Thursday. The work was better than our last agency&rsquo;s
            &mdash; at a third of the cost.&rdquo;
          </blockquote>
          <figcaption className="flex items-center gap-3.5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-coral-500 text-[16px] font-extrabold leading-none text-white">
              NA
            </span>
            <span>
              <span className="block text-[15px] font-bold leading-[1.3] text-cream-100">
                Nkechi A.
              </span>
              <span className="block text-[14px] leading-[1.5] text-cream-100/60">
                Head of Marketing, fintech scale-up
              </span>
            </span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
